<script setup>
import ListingDiscoveryCard from './ListingDiscoveryCard.vue';

defineProps({
  cards: { type: Array, default: () => [] },
  activeId: { type: [String, Number], default: '' },
});

const emit = defineEmits([
  'open',
  'hover',
  'toggle-select',
  'public-link',
  'share',
  'share-error',
  'viewed',
]);
</script>

<template>
  <div class="grid min-w-0 gap-3 overflow-hidden md:hidden">
    <ListingDiscoveryCard
      v-for="card in cards"
      :key="card.id"
      :card="card"
      :active="String(card.id) === String(activeId)"
      @open="payload => emit('open', payload)"
      @hover="payload => emit('hover', payload)"
      @toggle-select="payload => emit('toggle-select', payload)"
      @public-link="payload => emit('public-link', payload)"
      @share="
        (cardPayload, sharePayload) => emit('share', cardPayload, sharePayload)
      "
      @share-error="
        (cardPayload, error) => emit('share-error', cardPayload, error)
      "
      @viewed="payload => emit('viewed', payload)"
    />
  </div>
</template>
